















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import Navigation from "@/components/Navigation.vue";
import requestService from "@/service/requestService";
import { Getter } from "vuex-class";

@Component({
  components: {
    Header,
    SubHeader
  }
})
export default class Completed extends Vue {
  show = false;
  $refs!: {
    subHeader: SubHeader;
  };

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  onShowText() {
    if (!this.show) {
      this.show = true;
      const req = new requestService();
      const data = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        uketsukeCd: this.uketsukeCd,
        yoyakuNo: this.yoyakuNo
        , currentWorkProgressState: 14
      };
      req.saveCompleted(data).then(res => {
        this.$refs.subHeader.getSubHeaderData();
      });
    }
  }

  onClose() {
    this.$router.push({ name: "reservation" });
  }
}
